import React, { useMemo } from 'react';

interface HeaderProps {
  onBack?: () => void;
  onMinimize?: () => void;
  title?: string | React.ReactNode;
}

const Header = ({ onMinimize, onBack, title }: HeaderProps) => {
  const titleElement = useMemo(() => {
    if (typeof title === 'string') {
      return (
        <h2 className="sf:text-lg sf:font-semibold sf:text-gray-900">
          {title}
        </h2>
      );
    }

    if (React.isValidElement(title)) {
      return title;
    }

    return null;
  }, [title]);

  return (
    <div className="sf:flex sf:items-center sf:gap-3 sf:p-4">
      {onBack && (
        <button
          onClick={onBack}
          className="sf:p-2 sf:rounded-full sf:hover:bg-gray-100 sf:transition-colors sf:duration-200 sf:cursor-pointer"
          type="button"
        >
          <svg
            className="sf:w-5 sf:h-5 sf:text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
        </button>
      )}

      {titleElement}

      {onMinimize && (
        <div className="sf:ml-auto">
          <button
            onClick={onMinimize}
            className="sf:p-2 sf:rounded-full sf:hover:bg-gray-100 sf:transition-colors sf:duration-200 sf:cursor-pointer"
            type="button"
          >
            <svg
              className="sf:w-5 sf:h-5 sf:text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 12H4"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};
export default Header;
